import React from "react";

const NotFoundPage = () => {
  return (
    <div>
      <h2>404</h2>
      <p>Page Not Found</p>
    </div>
  );
};

export default NotFoundPage;



/** WEBPACK FOOTER **
 ** ./src/containers/NotFoundPage.js
 **/